import {
  clearClientCookie,
  CookieKeys,
  getClientCookie,
  useSession,
} from '@finn/ui-utils';
import axios from 'axios';
import { useEffect } from 'react';

export const useSaveConsent = () => {
  const [session] = useSession();
  useEffect(() => {
    const contactId = session?.user?.hs_contact_id;
    const consentCookie = getClientCookie(CookieKeys.NEWSLETTER_CONSENT);

    if (contactId && consentCookie) {
      clearClientCookie(CookieKeys.NEWSLETTER_CONSENT);
      axios.get('/api/updateConsent', {
        params: {
          consent: consentCookie === 'true' ? 'yes' : 'no',
        },
      });
    }
  }, [session]);
};
